export default __webpack_public_path__ + "static/media/montana.71e20a7c.jpg";